export const HASHTAG_LIST_TYPE = 'hashtag_list';
export const CAPTION_TYPE = 'caption';

export const TYPES = {
    [HASHTAG_LIST_TYPE]: {
        icon: 'hashtag',
        deleteTitle: 'title_hashtag_type',
        deleteBody: 'subtitleTitle_hashtag_type',
        popoverOptions: {
            placement: 'left',
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [15, 15]
                    }
                }
            ]
        }
    },
    [CAPTION_TYPE]: {
        icon: 'captions',
        deleteTitle: 'title_caption_type',
        deleteBody: 'subtitleTitle_caption_type',
        popoverOptions: {
            placement: 'left',
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [10, 10]
                    }
                }
            ]
        }
    }
};
